import { useEffect, useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { ShieldCheck, Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) { setState("error"); setMessage("Lien de vérification manquant."); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => { setState("error"); setMessage(formatApiError(e.response?.data?.detail) || "Erreur de vérification."); });
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 text-center space-y-4" data-testid="verify-email-page">
        <div className="w-14 h-14 rounded-2xl bg-emerald-500 flex items-center justify-center mx-auto"><ShieldCheck className="w-8 h-8 text-black" /></div>
        {state === "loading" && <><Loader2 className="w-8 h-8 animate-spin text-emerald-600 mx-auto" /><p className="text-sm text-slate-500">Vérification en cours…</p></>}
        {state === "ok" && <>
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" data-testid="verify-success" />
          <h2 className="font-heading text-xl font-bold text-slate-900">Adresse vérifiée</h2>
          <p className="text-sm text-slate-500">Votre adresse email a bien été confirmée.</p>
          <a href="/dashboard" className="inline-block mt-2 text-emerald-600 hover:underline text-sm font-medium">Aller au tableau de bord</a>
        </>}
        {state === "error" && <>
          <XCircle className="w-12 h-12 text-red-500 mx-auto" data-testid="verify-error" />
          <h2 className="font-heading text-xl font-bold text-slate-900">Vérification impossible</h2>
          <p className="text-sm text-slate-500">{message}</p>
          <a href="/login" className="inline-block mt-2 text-emerald-600 hover:underline text-sm font-medium">Retour à la connexion</a>
        </>}
      </div>
    </div>
  );
}
